import React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from "@mui/material"
import i18n from "@/i18n"

interface DeleteUserDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  deleting: boolean
}

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({ open, onClose, onConfirm, deleting }) => {
  return (
    <Dialog open={open} onClose={onClose} data-testid="settings-users-delete-dialog">
      <DialogTitle data-testid="settings-users-delete-dialog-title">
        {i18n.t("app.settings.users.list.delete_user")}
      </DialogTitle>
      <DialogContent>
        <p data-testid="settings-users-delete-dialog-message">{i18n.t("app.settings.users.list.delete_confirm")}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" data-testid="settings-users-delete-dialog-btn-cancel">
          {i18n.t("app.actions.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={deleting}
          data-testid="settings-users-delete-dialog-btn-confirm"
        >
          {deleting ? <CircularProgress size={24} /> : i18n.t("app.actions.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteUserDialog
